module.exports = __webpack_public_path__ + "img/perspective.b3f7f56a.svg";